module.exports = __webpack_public_path__ + "img/23.e33c6b6c.jpg";